import { useContext } from 'react'
import { MainContactContext } from '../context/MainContactContext'

const useContactContext = () => useContext(MainContactContext)

export default useContactContext
